import { authLogout } from 'actions/AuthActions'
import { pushWithRegion } from 'actions/NavigationActions'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import Modal from 'LuxKit/Modal/Modal'
import config from 'constants/config'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

function AgentHubAccountMenuModal() {
  const intl = useIntl()
  const dispatch = useAppDispatch()

  const { resolve } = useModalElementContext()

  const onLogout = useCallback(() => {
    dispatch(authLogout())
    dispatch(pushWithRegion('/'))
    resolve()
  }, [dispatch, resolve])

  const accountTitle = intl.formatMessage({
    id: 'fumjukCIrw6YS-UWdoe-',
    defaultMessage: 'Account',
    description: 'Modal title for agent hub account menu on the user account settings page',
  })

  const viewDashboardTitle = intl.formatMessage({
    id: 'G1i-18R2p3OPhynunnJV',
    defaultMessage: 'View dashboard',
    description: 'List item to navigate to agent portal dashboard in agent hub account menu modal',
  })

  const logOutTitle = intl.formatMessage({
    id: 'pQGqpi8HSJP5xDTqFuJo',
    defaultMessage: 'Log out',
    description: 'List item to log out in agent hub account menu modal',
  })

  return <Modal title={accountTitle}>
    <ClickableListItem title={viewDashboardTitle} href={config.AGENT_PORTAL_URL} target="_blank" />
    <ClickableListItem title={logOutTitle} onClick={onLogout} />
  </Modal>
}

export default AgentHubAccountMenuModal
